import { useMsal } from "@azure/msal-react";
import { msalConfig } from "Auth/authConfig";
import { useSignalR } from "./UseSignalR";
import { removeCookie } from "Common/Functions";

export const useLogout = () => {
  const { instance } = useMsal();
  const { startConnection, sendLogoutRequest, isConnected } = useSignalR();

  const handleLogout = async () => {
    const localAccountId = instance.getActiveAccount()?.localAccountId;

    if (localAccountId) {
      try {
        if (!isConnected()) {
          await startConnection();
        }
        await sendLogoutRequest(localAccountId);

        const logoutRequest = {
          account: instance.getActiveAccount(),
          postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
        };
        instance.logoutRedirect(logoutRequest);
        localStorage.setItem("isUserLoggedOut", "true");
        localStorage.removeItem("isLoginProcessed");
        removeCookie("currentuserid");
      } catch (error) {
        console.error("Error sending logout request:", error);
      }
    }
  };

  return { handleLogout };
};
